import { useCallback } from 'react';
import Toast, { type ToastShowParams } from 'react-native-toast-message';
import type { ToastType } from '~/components/Toast';

interface ShowToastParams extends Omit<ToastShowParams, 'text1' | 'text2'> {
  title?: string;
  description?: string;
  type?: ToastType;
}

function useToast() {
  const showToast = ({
    title,
    description,
    type,
    ...rest
  }: ShowToastParams) => {
    Toast.show({ ...rest, type, text1: title, text2: description });
  };

  const showSuccess = useCallback(
    ({ title, description, ...rest }: ShowToastParams) => {
      showToast({ title, description, type: 'success', ...rest });
    },
    []
  );

  const showWarning = useCallback(
    ({ title, description, ...rest }: ShowToastParams) => {
      showToast({ title, description, type: 'warning', ...rest });
    },
    []
  );

  const showError = useCallback(
    ({ title, description, ...rest }: ShowToastParams) => {
      showToast({ title, description, type: 'error', ...rest });
    },
    []
  );

  const showModalAlertIdle = useCallback((rest: ShowToastParams) => {
    showToast({ type: 'modalAlertIdle', ...rest });
  }, []);

  const showModalAlert = useCallback((rest: ShowToastParams) => {
    showToast({ type: 'modalConfirmationToast', autoHide: false, ...rest });
  }, []);

  const hideToast = useCallback(() => {
    Toast.hide();
  }, []);

  return {
    showToast,
    showSuccess,
    showWarning,
    showError,
    hideToast,
    showModalAlertIdle,
    showModalAlert,
  };
}

export default useToast;
